import { Component, OnInit } from '@angular/core';
import { skipWhile, take } from 'rxjs/operators';
import { BigFormService, StoreQuery, VatService, getInvoice, getSP } from '@flexus/core';
import { combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
	selector: 'flx-invoice-specifics',
	templateUrl: './invoice-specifics.component.html',
	styleUrls: ['./invoice-specifics.component.scss']
})
export class FLXBillingInvoiceSpecificsComponent implements OnInit {
	sp: any;
	invoice: any;
	constructor(private sq: StoreQuery, private bf: BigFormService, private store: Store<any>) {}

	ngOnInit() {
		combineLatest([this.store.select(getSP), this.store.select(getInvoice)])
			.pipe(
				skipWhile(x => !x[0] || !x[1]),
				take(1)
			)
			.subscribe(([sp, invoice]) => {
				console.log({ sp, invoice });
				this.sp = sp;
				const excess_amount = this.bf.bigForm.get('itemTwo')?.value?.excess?.amount ?? '0.00';
				const validInvoice = invoice.payload.error !== 'No invoice or quotation found!';

				if (!!(sp && sp.vat_no)) {
					const date_split = validInvoice ? this.bf.bigForm.get('invoiceDate')?.value?.toString()?.split('T')[0]?.split('-') : new Date();
					const vatPercent = VatService.getVatPercentageFromDate(new Date(this.bf.bigForm.get('invoiceDate')?.value));
					const vatRate = VatService.getVatRate(validInvoice ? invoice.total : '0.00', vatPercent);
					const total = Number(validInvoice ? invoice.subtotal : '0') + vatRate;

					this.invoice = {
						note: validInvoice ? invoice.note : '',
						balance_due: validInvoice ? invoice.balance_due : '0.00',
						less_excess: excess_amount,
						total: total,
						vat: vatRate,
						vat_rate: vatPercent,
						subtotal: validInvoice ? invoice.subtotal : '0.00',
						calcVat: !!(sp && sp.vat_no)
					};
				} else {
					this.invoice = {
						note: validInvoice ? invoice.note : '',
						balance_due: validInvoice ? invoice.balance_due : '0.00',
						less_excess: excess_amount,
						total: validInvoice ? invoice.total : '0.00',
						vat: 0,
						vat_rate: 0,
						subtotal: validInvoice ? invoice.subtotal : '0.00',
						calcVat: !!(sp && sp.vat_no)
					};
				}
			});
	}
}
